import { MotorStepType } from 'scenes/motor/types';

export const motorPageTitles: {
  [key in MotorStepType]: string;
} = {
  [MotorStepType.Name]: 'First and last name',
  [MotorStepType.GenderAndDateOfBirth]: 'Gender and date of birth',
  [MotorStepType.OvernightParking]: 'Overnight parking address',
  [MotorStepType.YearsDriving]: 'Driving history',
  [MotorStepType.ClaimsMade]: 'Claims made',
  [MotorStepType.PayableClaims]: 'Payable claims',
  [MotorStepType.RecentInsurer]: 'Recent insurer',
  [MotorStepType.UsedForBusiness]: 'Used for business',
  [MotorStepType.BusinessType]: 'Type of business',
  [MotorStepType.Finance]: 'Car finance',
  [MotorStepType.VehicleFinancier]: 'Car financier',
  [MotorStepType.CoverForDriversUnder25]: 'Under 25 driver cover',
  [MotorStepType.PolicyStartDate]: 'Policy start date',
  [MotorStepType.AddDriver]: 'Additional drivers',
  [MotorStepType.RegoSearch]: 'Car search',
  [MotorStepType.VehicleManualSelect]: 'Select car',
  [MotorStepType.VehicleDetails]: 'Confirm car',
  [MotorStepType.FlybuysNumber]: 'Flybuys',
  [MotorStepType.PromoCode]: 'Promotional code',
  [MotorStepType.QuotePrice]: 'Your quote price',
  [MotorStepType.Excess]: 'Excess',
  [MotorStepType.MarketAgreedValue]: 'Market or agreed value',
  [MotorStepType.OptionalExtras]: 'Optional extras',
  [MotorStepType.PersonalOrBusinessPolicy]: 'Issued to person or business',
  [MotorStepType.BusinessNameAndAbn]: 'Business details',
  [MotorStepType.BusinessRegisteredForGst]: 'Registered for GST',
  [MotorStepType.AddPolicyHolder]: 'Add policy holders',
  [MotorStepType.PersonalPolicyContact]: 'Policy contact',
  [MotorStepType.BusinessContact]: 'Business contact',
  [MotorStepType.ContactPhoneNumber]: 'Contact phone number',
  [MotorStepType.ContactEmailAddress]: 'Contact email address',
  [MotorStepType.PostalAddress]: 'Postal address',
  [MotorStepType.DifferentPostalAddress]: 'Postal address',
  [MotorStepType.DifferentPostalAddressManual]: 'Postal address',
  [MotorStepType.LockedBagAddress]: 'Locked bag address',
  [MotorStepType.PreExistingDamage]: 'Preexisting damage',
  [MotorStepType.Modifications]: 'Modifications & accessories',
  [MotorStepType.ModificationSelection]: 'Select modifications',
  [MotorStepType.SpecialFeatures]: 'Special features',
  [MotorStepType.SpecialDetails]: 'Declarations',
  [MotorStepType.InsuredSincePossessed]: 'Insured since possession',
  [MotorStepType.MissingRegoStep]: 'Enter your rego',
  [MotorStepType.TermsAndConditions]: 'Terms and conditions',
  [MotorStepType.Summary]: 'Review summary',
  [MotorStepType.PaymentFrequency]: 'Payment frequency',
  [MotorStepType.PaymentDate]: 'Payment date',
  [MotorStepType.PaymentMethod]: 'Payment method',
  [MotorStepType.DirectDebitPayment]: 'Direct debit payment',
  [MotorStepType.CreditCardPayment]: 'Credit card payment',
  [MotorStepType.PaymentConfirmation]: 'Payment confirmation',
  [MotorStepType.ReviewPolicyStartDate]: 'Review policy start date',
  [MotorStepType.ReviewDriverDetails]: 'Review driver details',
  [MotorStepType.addDriverName]: 'Add driver name',
};

export default motorPageTitles;
